import React, { FC, PropsWithChildren } from "react"
import { Navigate, To } from "react-router-dom"

import { FullscreenLoader } from "../../../../components/fallbacks/FullscreenLoader"
import { useLanguage } from "../../../../contexts/language-context"
import { useAuth } from "../../../../contexts/authentication-context"

type RequiresAuthProps = {
    redirect?: To
}

const RequiresAuth: FC<PropsWithChildren<RequiresAuthProps>> = ({ redirect = "/signin", children }) => {
    const { isAuth } = useAuth()
    const { L } = useLanguage()

    if (isAuth === null) return <FullscreenLoader label={L("Authenticating...")} />
    else if (!isAuth) return <Navigate to={redirect} />
    else return <>{children}</>
}

export default RequiresAuth
